import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import {
  columnActive,
  columnCreatedBy,
  columnCreatedByLink,
  columnReason,
  columnMultiSelect,
  columnName,
  columnRole,
  columnRoleLink,
  columnIpAddress,
  columnTools,
  columnValidFrom,
  columnValidTo,
} from '@/constants/fields';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableHeader from '@/components/table/TableHeader';
import Filter from '@/components/Filter';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import TokensTableColumns from '../containers/TokensTableColumns';
import TokensTableRows from '../containers/TokensTableRows';
import TokensFilters from '../containers/TokensFilters';
import myTokens from '../helper';

const buildColumns = (category, allowRoleLink, allowUserLink) => {
  const columns = [columnMultiSelect, columnName, columnIpAddress, columnReason,
    columnValidFrom, columnValidTo, columnActive, columnTools];
  const forMe = myTokens(category);

  if (allowRoleLink) {
    columns.push(columnRoleLink);
  } else {
    columns.push(columnRole);
  }

  if (!forMe && allowUserLink) {
    columns.push(columnCreatedByLink);
  } else if (!forMe) {
    columns.push(columnCreatedBy);
  }

  return columns;
};

const TokensTable = ({
  category,
  tokens,
  readStatus,
  readErrors,
  filterTerm,
  total,
  pageCount,
  pageSize,
  currentPage,
  fetchData,
  updateFilterTerm,
  allowRoleLink,
  allowUserLink,
  canCreate,
  newToken,
}) => {
  const { items, pageNumber } = fitToPage(tokens, currentPage, pageSize);
  const ref = React.useRef(null);
  const columns = buildColumns(category, allowRoleLink, allowUserLink);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-tokens-table" column={columns}>
        <Table.Header>
          <TableHeader
            isLoading={readStatus === states.PENDING}
            error={firstErrorMessage(readErrors)}
            numberOfColumns={columns.length}
          >
            <Filter
              className="aridhia-table-filter"
              filterTerm={filterTerm}
              error={firstErrorMessage(readErrors)}
              updateFilter={({ value }) => updateFilterTerm(category, value)}
              onFilter={() => fetchData(category, 1, null, false)}
              label={<TokensFilters category={category} />}
            />
          </TableHeader>
          <TokensTableColumns category={category} items={items} columns={columns} />
        </Table.Header>
        <Table.Body>
          <TokensTableRows category={category} items={items} columns={columns} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        canCreate={canCreate}
        currentPage={pageNumber}
        entity="token"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="code"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
        onClick={newToken}
      />
    </div>
  );
};

export default TokensTable;
